


import React, { useState, useEffect } from 'react';



import { callApi } from './api';







function EditUserForm({ user, onFinished }) {



  // Auth fields



  const [email, setEmail] = useState('');



  const [displayName, setDisplayName] = useState('');







  // Firestore profile fields (for L1)



  const [phone, setPhone] = useState('');



  const [address, setAddress] = useState('');



  const [unit, setUnit] = useState('');



  const [parking, setParking] = useState('');







  const [error, setError] = useState(null);



  const [loading, setLoading] = useState(false);







  const isLevel1User = user?.customClaims?.role?.level === 1;







  useEffect(() => {



    if (user) {



      setEmail(user.email || '');



      setDisplayName(user.displayName || '');



      if (isLevel1User) {



        setPhone(user.phone || '');



        setAddress(user.address || '');



        setUnit(user.unit || '');



        setParking(user.parking || '');



      }



    }



  }, [user, isLevel1User]);







  if (!user) return null;







  const handleUpdateUser = async (e) => {



    e.preventDefault();



    setError(null);



    setLoading(true);







    const updatePayload = {



      uid: user.uid,



      email,



      displayName,



    };







    if (isLevel1User) {



      Object.assign(updatePayload, { phone, address, unit, parking });



    }







    try {



      await callApi('updateUserV2', updatePayload);



      if (onFinished) onFinished();



    } catch (err) {



      setError('Kunne ikke oppdatere bruker. ' + err.message);



      console.error(err);



    } finally {



      setLoading(false);



    }



  };







  const handleDeleteUser = async () => {



    if (window.confirm(`Er du sikker på at du vil slette brukeren "${user.displayName}"?`)) {



        setLoading(true);



        setError(null);



        try {



            await callApi('deleteUserV2', { uid: user.uid });



            if (onFinished) onFinished();



        } catch (err) {



            setError(`Kunne ikke slette bruker: ${err.message}`);



        } finally {



            setLoading(false);



        }



    }



  };







  return (



    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>



      <form onSubmit={handleUpdateUser} style={{ background: 'var(--background-light)', color: 'var(--text-light)', padding: '20px', borderRadius: '5px', display: 'flex', flexDirection: 'column', gap: '15px', minWidth: '350px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>



        <h3>Rediger Bruker</h3>



        



        <div>



          <label htmlFor="edit-email" style={{ display: 'block', marginBottom: '5px' }}>E-post</label>



          <input id="edit-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />



        </div>







        <div>



          <label htmlFor="edit-displayName" style={{ display: 'block', marginBottom: '5px' }}>Fullt navn</label>



          <input id="edit-displayName" type="text" value={displayName} onChange={(e) => setDisplayName(e.target.value)} required />



        </div>







        {isLevel1User && (



          <>



            <h4>Brukerprofil</h4>



            <div>



              <label htmlFor="edit-phone" style={{ display: 'block', marginBottom: '5px' }}>Telefonnummer</label>



              <input id="edit-phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />



            </div>



            <div>



              <label htmlFor="edit-address" style={{ display: 'block', marginBottom: '5px' }}>Adresse</label>



              <input id="edit-address" type="text" value={address} onChange={(e) => setAddress(e.target.value)} />



            </div>



            <div>



              <label htmlFor="edit-unit" style={{ display: 'block', marginBottom: '5px' }}>Boenhet / Leilighetsnr.</label>



              <input id="edit-unit" type="text" value={unit} onChange={(e) => setUnit(e.target.value)} />



            </div>



            <div>



              <label htmlFor="edit-parking" style={{ display: 'block', marginBottom: '5px' }}>Parkeringsplass</label>



              <input id="edit-parking" type="text" value={parking} onChange={(e) => setParking(e.target.value)} />



            </div>



          </>



        )}







        {error && <p style={{ color: 'red' }}>{error}</p>}







        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>



            <button type="button" onClick={handleDeleteUser} disabled={loading} style={{backgroundColor: '#ff4d4d'}}>Slett Bruker</button>



            <div>



                <button type="button" onClick={onFinished} style={{marginRight: '10px'}}>Avbryt</button>



                <button type="submit" disabled={loading}>



                    {loading ? 'Lagrer...' : 'Lagre'}



                </button>



            </div>



        </div>



      </form>



    </div>



  );



}







export default EditUserForm;


















